module.exports = __webpack_public_path__ + "img/数据交换.db3d9afe.svg";